export type BlogCopy = {
  heroTitleBefore: string;
  heroTitleHighlight: string;
  heroSub: string;
  heroCta: string;
  followUs: string;
  floatCardLabel: string;
  floatTopics: [string, string, string];
  floatBadgeLabel: string;
  floatBadgeValue: string;
  latestTitle: string;
  latestSub: string;
  readMore: string;
  emptyTitle: string;
  emptyDesc: string;
  backToBlog: string;
  relatedTitle: string;
  ctaTitle: string;
  ctaSub: string;
  ctaButton: string;
  readMinutes: (n: number) => string;
  footerTagline: string;
  footerProduct: string;
  footerCompany: string;
  footerSupport: string;
  footerLegal: string;
  footerShifts: string;
  footerAttendance: string;
  footerContracts: string;
  footerHiring: string;
  footerAbout: string;
  footerCareers: string;
  footerBlog: string;
  footerHelp: string;
  footerContact: string;
  footerStatus: string;
  footerGdpr: string;
  footerTerms: string;
  footerCookies: string;
  footerPrivacy: string;
  footerTermsShort: string;
  loadError: string;
  notFoundTitle: string;
  notFoundDesc: string;
};

const CS: BlogCopy = {
  heroTitleBefore: 'Tipy pro firmy',
  heroTitleHighlight: 'brigádníky',
  heroSub:
    'Praktické návody k plánování směn, docházce a náboru - a zkušenosti firem i brigádníků, kteří v Ompli řeší provoz každý den.',
  heroCta: 'Čtěte nejnovější články',
  followUs: 'Sledujte nás',
  floatCardLabel: 'náhled článku',
  floatTopics: ['Rozpis bez chaosu', 'Papíry k brigádě', 'Novinky v appce'],
  floatBadgeLabel: 'Nové čtení',
  floatBadgeValue: 'každé dva týdny',
  latestTitle: 'Nejnovější články',
  latestSub: 'Nové čtení každé dva týdny - bez omáčky, jen to, co vám ušetří čas.',
  readMore: 'Číst více',
  emptyTitle: 'Zatím žádné články',
  emptyDesc: 'Brzy tu najdete tipy k směnám, docházce a náboru.',
  backToBlog: 'Zpět na blog',
  relatedTitle: 'Další články',
  ctaTitle: 'Naplánujte první rozpis do 20 minut',
  ctaSub: 'Zkuste Ompli do 5 zaměstnanců zdarma, bez zadávání karty.',
  ctaButton: 'Vyzkoušet zdarma',
  readMinutes: (n) => `${n} min čtení`,
  footerTagline: 'Směny, docházka, smlouvy a nábor v jedné aplikaci pro rostoucí firmy.',
  footerProduct: 'Produkt',
  footerCompany: 'Společnost',
  footerSupport: 'Podpora',
  footerLegal: 'Právní',
  footerShifts: 'Směny',
  footerAttendance: 'Docházka',
  footerContracts: 'Smlouvy',
  footerHiring: 'Nábor',
  footerAbout: 'O nás',
  footerCareers: 'Kariéra',
  footerBlog: 'Blog',
  footerHelp: 'Nápověda',
  footerContact: 'Kontakt',
  footerStatus: 'Stav služby',
  footerGdpr: 'GDPR',
  footerTerms: 'Obchodní podmínky',
  footerCookies: 'Cookies',
  footerPrivacy: 'Ochrana soukromí',
  footerTermsShort: 'Podmínky',
  loadError: 'Články se nepodařilo načíst.',
  notFoundTitle: 'Článek nenalezen',
  notFoundDesc: 'Tento článek neexistuje nebo už není publikovaný.',
};

const EN: BlogCopy = {
  heroTitleBefore: 'Tips for companies',
  heroTitleHighlight: 'temps',
  heroSub:
    'Practical guides to shift planning, attendance, and hiring - plus stories from teams who run operations in Ompli every day.',
  heroCta: 'Read the latest articles',
  followUs: 'Follow us',
  floatCardLabel: 'article preview',
  floatTopics: ['Schedules without chaos', 'Temp paperwork', 'App updates'],
  floatBadgeLabel: 'New reading',
  floatBadgeValue: 'every two weeks',
  latestTitle: 'Latest articles',
  latestSub: 'Fresh reading every two weeks - no fluff, just what saves you time.',
  readMore: 'Read more',
  emptyTitle: 'No articles yet',
  emptyDesc: 'Tips on shifts, attendance, and hiring are coming soon.',
  backToBlog: 'Back to blog',
  relatedTitle: 'More articles',
  ctaTitle: 'Plan your first schedule in 20 minutes',
  ctaSub: 'Try Ompli free for up to 5 employees, no card required.',
  ctaButton: 'Try for free',
  readMinutes: (n) => `${n} min read`,
  footerTagline: 'Shifts, attendance, contracts, and hiring in one app for growing teams.',
  footerProduct: 'Product',
  footerCompany: 'Company',
  footerSupport: 'Support',
  footerLegal: 'Legal',
  footerShifts: 'Shifts',
  footerAttendance: 'Attendance',
  footerContracts: 'Contracts',
  footerHiring: 'Hiring',
  footerAbout: 'About',
  footerCareers: 'Careers',
  footerBlog: 'Blog',
  footerHelp: 'Help',
  footerContact: 'Contact',
  footerStatus: 'Status',
  footerGdpr: 'GDPR',
  footerTerms: 'Terms of service',
  footerCookies: 'Cookies',
  footerPrivacy: 'Privacy',
  footerTermsShort: 'Terms',
  loadError: 'Failed to load articles.',
  notFoundTitle: 'Article not found',
  notFoundDesc: 'This article does not exist or is no longer published.',
};

export function getBlogCopy(lang: 'cs' | 'en'): BlogCopy {
  return lang === 'en' ? EN : CS;
}
